import React, { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';

import * as S from './MyBizBlogStyle';
import {
	GenericDiv,
	Heading,
	GenericP
} from 'commonStyles';
import { OrangeBorder, MyBizBlogSubTitle } from '../../Style';
import { trackClickEventSimple } from 'omnitures';

const MyBizBlog = ({ isMobile }) => {
	const blogsData = useSelector((state) => state.resource.blogsData || {});
	const { content = [], heading = '', subHeading = '' } = blogsData;

	const sliderRef = useRef();

	function SampleNextArrow(props) {
		const { className, onClick } = props;
		return !isMobile ? (
			<S.ArrowNextButton className={className} onClick={onClick}> NEXT </S.ArrowNextButton>
		) : null;
	}

	function SamplePrevArrow(props) {
		const { className, onClick } = props;
		return !isMobile ? (
			<S.ArrowPrevButton className={className} onClick={onClick}> PREVIOUS </S.ArrowPrevButton>
		) : null;
	}

	const goToSlide = (i) => () => {
		sliderRef && sliderRef.current && sliderRef.current.slickGoTo(i);
	};

	const settings = useMemo(() => ({
		swipeToSlide: true,
		dots: true,
		infinite: false,
		slidesToShow: isMobile ? 1 : 3,
		slidesToScroll: isMobile ? 1 : 3,
		rows: isMobile ? 1 : 2,
		arrows: true,
		nextArrow: <SampleNextArrow />,
		prevArrow: <SamplePrevArrow />,
		appendDots: (dots) => (
			<S.CustomSlideNumbers>
				<ul> {dots} </ul>
			</S.CustomSlideNumbers>
		),
		customPaging: (i) => (
			<>
				{!isMobile &&
					<GenericDiv color='#0091FF' onClick={goToSlide(i * 3)}>
						{i + 1}
					</GenericDiv>}
			</>
		),

		responsive: [
			{
				settings: {
					variableWidth: false,
					slidesToShow: 1.1,
					rows: 1,
					slidesToScroll: 1,
					dots: false,
					arrows: false
				}
			}
		]
	}), [isMobile]);

	const openBlogs = (url, heading) => () => {
		trackClickEventSimple(heading + '_clicked');
		window.location.href = url;
	};

	return (
		<S.Wrapper id='MyBizBlog'>
			<S.BizContainer>
				<OrangeBorder />
				<GenericDiv left_P={`${isMobile ? '16' : 'auto'}`}>
					<Heading
						fontSize={`${isMobile ? '24px' : '40px'}`}
						marBt={`${isMobile ? '8px' : '5px'}`}
						dangerouslySetInnerHTML={{ __html: heading }}
					/>
				</GenericDiv>
				<MyBizBlogSubTitle>
					{subHeading}
				</MyBizBlogSubTitle>
				<S.MyBizBlogList>
					<Slider {...settings} ref={sliderRef}>
						{content.map((item, index) => {
							const { imgUrl, date, heading, contentUrl } = item;
							return (
								<S.MyBizBlogItem key={imgUrl} id={`blogs${index}`} onClick={openBlogs(contentUrl, heading)}>
									<img className='appendBottom16' src={imgUrl} />
									<GenericP top_M='10' bottom_M='4' fsize='12px'>{date}</GenericP>
									<GenericP fsize={`${isMobile ? '20px' : '22px'}`} color='#3b385e'>
										{heading}
									</GenericP>
								</S.MyBizBlogItem>
							);
						})}
					</Slider>
				</S.MyBizBlogList>
			</S.BizContainer>
		</S.Wrapper>
	);
};

export default MyBizBlog;
